import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=77e7e53d&scoped=true&"
import script from "./switch.vue?vue&type=script&lang=js&"
export * from "./switch.vue?vue&type=script&lang=js&"
import style0 from "./switch.vue?vue&type=style&index=0&id=77e7e53d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e7e53d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e7e53d')) {
      api.createRecord('77e7e53d', component.options)
    } else {
      api.reload('77e7e53d', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=77e7e53d&scoped=true&", function () {
      api.rerender('77e7e53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/form/switch.vue"
export default component.exports